/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Bodyfat_LabelInputs */

const en_us2_profile_editors_bodyfat_label = /** @type {(inputs: Profile_Editors_Bodyfat_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body fat percentage`)
};

const pt_br2_profile_editors_bodyfat_label = /** @type {(inputs: Profile_Editors_Bodyfat_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentual de gordura`)
};

const es_419_profile_editors_bodyfat_label = /** @type {(inputs: Profile_Editors_Bodyfat_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porcentaje de grasa corporal`)
};

const pt_pt2_profile_editors_bodyfat_label = /** @type {(inputs: Profile_Editors_Bodyfat_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentagem de gordura`)
};

const fr_fr2_profile_editors_bodyfat_label = /** @type {(inputs: Profile_Editors_Bodyfat_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourcentage de masse grasse`)
};

const de_de2_profile_editors_bodyfat_label = /** @type {(inputs: Profile_Editors_Bodyfat_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körperfettanteil`)
};

const it_it2_profile_editors_bodyfat_label = /** @type {(inputs: Profile_Editors_Bodyfat_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentuale di grasso`)
};

/**
* | output |
* | --- |
* | "Body fat percentage" |
*
* @param {Profile_Editors_Bodyfat_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_bodyfat_label = /** @type {((inputs?: Profile_Editors_Bodyfat_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Bodyfat_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_bodyfat_label(inputs)
	if (locale === "es-419") return es_419_profile_editors_bodyfat_label(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_bodyfat_label(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_bodyfat_label(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_bodyfat_label(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_bodyfat_label(inputs)
	return en_us2_profile_editors_bodyfat_label(inputs)
});
export { profile_editors_bodyfat_label as "profile-editors.bodyfat_label" }